//
//
//
//

import { call } from 'vuex-pathify'
import RolChip from './RolChip'
export default {
  components: { RolChip },

  props: {
    value: {
      type: Object | undefined,
      required: true
    },
  },

  computed: {
    rol: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },

  methods: {
    filter: call('app/search'),
  }
}
